import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getInformesMedicos } from '../../../../actions/turnos/estudiosMedicos';
import { clearProtocolo, TraerProtocoloImagenes } from '../../../../actions/hce/hceActions';
import { validarSoloUnPermiso } from '../../../../helpers/permisos';
import { HCE_PERMISOS } from '../../../../utils/permisos';
import { Button, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import { InformesHistorialItem } from '../../../HCE/ListadoPacientes/ModalHce/InformesHCE/InformesHistorialItem';
import { ModalIngresoInforme } from '../informes/ModalIngresoInforme';

export const InformesMenu = (props) => {

  const dispatch = useDispatch();
  const [openModalInforme, setOpenModalInforme] = useState(false);

  const {
    estudioMedicoSeleccionado = {},
    informes
  } = useSelector((state) => state.estudiosMedicos);
  const { protocolos } = useSelector((state) => state.hce);
  const { permisos: permisosUser } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getInformesMedicos(estudioMedicoSeleccionado?.idAgenda));
    dispatch(TraerProtocoloImagenes(estudioMedicoSeleccionado?.idEfectorRedSolicitado));
  }, [dispatch]);

  return (
    <React.Fragment>
      {openModalInforme && (
        <ModalIngresoInforme
          open={openModalInforme}
          close={() => {
            setOpenModalInforme(false);
          }}
          disabled={props.disabled}
          estudioMedicoSeleccionado={estudioMedicoSeleccionado}
          protocolos={protocolos}
        />
      )}
      {validarSoloUnPermiso(permisosUser, HCE_PERMISOS.INFORMES) && (
        <div style={{ textAlign: 'center', margin: '1rem 0' }}>
          <Button
            disabled={informes[0]?.id > 0 ? true : false}
            variant="contained"
            color="primary"
            onClick={() => {
              setOpenModalInforme(true);
              dispatch(clearProtocolo());
            }}
          >
            + Ingresar Informe
          </Button>
        </div>
      )}
      {Array.isArray(informes) && informes?.length > 0 ? (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ width: '15%' }}>Nombre Informe</TableCell>
              <TableCell style={{ width: '6%' }}>
                Nombre Profesional
              </TableCell>
              <TableCell style={{ width: '10%' }}>Fecha</TableCell>
              <TableCell style={{ width: '10%' }}>Informe</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {informes.map((informe, index) => {
              return (
                <InformesHistorialItem
                  key={informe?.id.toString()}
                  informe={informe}
                  turnos={true}
                />
              );
            })}
          </TableBody>
        </Table>
      ) : (
        <Typography style={{ fontSize: '1.1rem', fontStyle: 'italic' }}>
          No se encuentran informes
        </Typography>
      )}
    </React.Fragment>
  )
}
